import { loadScript, removeScript } from '../../helpers';
export class LoginWithFacebookHandler {
    static SDK_URL = 'https://connect.facebook.net/en_US/sdk.js';
    static SDK_ID = 'facebook-sdk';
    configs;
    constructor(clientId, ssoServerUrl) {
        this.configs = {
            clientId,
            ssoServerUrl,
        };
    }
    signIn(options) {
        return new Promise(async (resolve) => {
            const status = await this.loadSDK();
            if (!status)
                return resolve([undefined, '(!) Facebook SDK failed to load']);
            if (options?.uxMode === 'redirect') {
                this.getLoginUrl(options);
                return resolve(['']);
            }
            window.FB.login((fbSignInResponse) => {
                if (!fbSignInResponse.authResponse || fbSignInResponse.status !== 'connected') {
                    resolve([, 'Login failed']);
                }
                const token = fbSignInResponse.authResponse.accessToken;
                resolve([token]);
            }, { scope: 'public_profile,email', auth_type: 'rerequest', enable_profile_selector: true });
        });
    }
    signOut() {
        window.FB.getLoginStatus((response) => {
            if (response.authResponse && response.status === 'connected') {
                window.FB.logout();
            }
        });
    }
    loadSDK() {
        return new Promise(resolve => {
            if (window.FB) {
                return resolve(true);
            }
            loadScript(LoginWithFacebookHandler.SDK_URL, LoginWithFacebookHandler.SDK_ID, {
                onLoad: () => {
                    window.fbAsyncInit = () => {
                        window.FB.init({
                            appId: this.configs.clientId,
                            cookie: true,
                            xfbml: true,
                            version: 'v15.0',
                            autoLogAppEvents: false,
                        });
                    };
                    resolve(true);
                },
                onError: () => {
                    console.debug('(!) Facebook SDK failed to load');
                    resolve(false);
                },
            });
        });
    }
    getLoginUrl(opts) {
        const params = Object.entries({
            client_id: this.configs.clientId,
            redirect_uri: opts.redirectUrl,
            response_type: 'code,token',
            scope: 'public_profile,email',
            auth_type: 'rerequest',
            enable_profile_selector: true,
            state: JSON.stringify(opts.state),
        })
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `https://www.facebook.com/v15.0/dialog/oauth?${params}`;
        window.location.href = url;
    }
    removeSDK() {
        removeScript(LoginWithFacebookHandler.SDK_ID);
    }
}
//# sourceMappingURL=facebook.js.map